import React from "react"

import styles from './header.module.scss'

export const Header: React.FC = () => {
  return (
    <div className={styles.header}>
      Header component
    </div>
  )
}